import PropTypes from 'prop-types';
import { HSText } from '@/Components/Common/HSWidget';

export const DateTimeTile = ({ date, time }) => (
  <div className="time-container">
    <HSText className="card-today-title">{date}</HSText>
    <HSText className="card-today-value">{time}</HSText>
  </div>
);

DateTimeTile.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

export default DateTimeTile;
